import { Box } from "@chakra-ui/react";
import React from "react";

interface IContainerLayoutGestap {
    children: React.ReactNode
    className?: string
}

const ContainerLayout = ({ children, className }: IContainerLayoutGestap) => {
    return (<>
        <Box flexDirection={'column'} position={'relative'} display={'flex'} flex={1} role="main" className={className}>
            {children}
        </Box>
    </>);
}

export default ContainerLayout;